import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../auth/service/utils.service";

@Component({
  selector: "app-loader",
  template: ``,
  styles: [],
})
export class LoaderComponent implements OnInit {

  constructor(public _utilService: UtilsService) {
  }

  ngOnInit() {
    this._utilService.pageIsLoading.subscribe((show: boolean) => {
      const loader = document.querySelector("#loading-box");
      const modal = document.querySelector('ngb-modal-window');
      if (show) {
        loader?.classList.add('active');
        modal?.classList.add('d-none');
        modal?.classList.remove('d-block');
      } else {
        loader?.classList.remove('active');
        modal?.classList.remove('d-none');
        modal?.classList.add('d-block');
      }
    });
  }

}
